import { motion } from "framer-motion";
import { MicVocal, PartyPopper, Award, Camera, TrendingUp, Sparkles } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { fadeUp, stagger, viewportOnce } from "../../lib/motion";
import { useLang } from "../../i18n/LanguageContext";

const ICONS = [MicVocal, PartyPopper, Award, Camera, TrendingUp, Sparkles];

export const OurPromise = () => {
  const { t } = useLang();
  const s = t.promise;
  return (
    <section id="promise" data-testid="promise-section" className="relative overflow-hidden bg-ink-800 py-24 md:py-32 grain">
      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-8">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} accent={s.accent} testid="promise-heading" />
        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={viewportOnce} className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {s.cards.map((p, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <motion.div
                key={i}
                variants={fadeUp}
                data-testid={`promise-card-${i}`}
                className="group relative overflow-hidden rounded-2xl glass p-8 transition-colors duration-300 hover:border-gold-light/50"
              >
                <span className="absolute -right-4 -top-6 font-display text-8xl font-semibold text-white/5 transition-colors group-hover:text-gold-light/10">{i + 1}</span>
                <span className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-gold-light to-gold-primary text-ink-900">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="font-display text-2xl font-medium text-white">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-white/65">{p.note}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
